import { createCompassModalSwitcher } from "@circle-react/components/SettingsApp/CompassCompat/createCompassModalSwitcher";

import { LikesModalComponent } from "./LikesModalComponent";
import { LikesModalUIKitComponent } from "./LikesModalUIKitComponent";

export const useLikesModal = createCompassModalSwitcher(
  LikesModalComponent,
  LikesModalUIKitComponent,
);
